import Layout from './views/portfolio/Layout'
import Home from './views/portfolio/Content/Homepage'
import Contact from './views/portfolio/Content/Contact'
import Service from './views/portfolio/Content/Service'
import Project from './views/portfolio/Content/Project'
import Collaboration from './views/portfolio/Content/Collaboration'
import Insight from './views/portfolio/Content/Insight'
import Style from './views/portfolio/Content/Style'
import NotFound from './views/portfolio/Content/404'

import HomeLayout from './views/teaser/HomeLayout'
import HomePage_Teaser from './views/teaser/Homepage'
import Calendly from './views/teaser/Calendly'

const routes = [
  { path: '/dev', component: HomeLayout, children: [
      { path: '', name: 'HomePage', component: HomePage_Teaser },
      { path: 'book', name: 'Calendly', component: Calendly },
      { path: '*', component: { render (h) { return h('div', '404. Not Found.') } } }
    ]
  },
  {
  path: '/boolland', beforeEnter() { const base = process.env.BASE_URL || '/'; window.location.replace(base + 'static/boolland_globe.html');}},
  {
    path: '/', component: Layout, children: [
      { path: '', name: 'Home', component: Home },
      { path: 'contact', name: 'Contact', component: Contact },
      { path: 'service', name: 'Service', component: Service },
      { path: 'project', name: 'Project', component: Project },
      { path: 'collaboration', name: 'Collaboration', component: Collaboration },
      { path: 'insight', name: 'Insight', component: Insight },
      { path: 'style', name: 'Style', component: Style },
      { path: '*', name: 'NotFound', component: NotFound },
    ],
  },
  { path: '*', component: { render (h) { return h('div', 'Woops! 404. Not Found.') } } }
]

export default routes


// WEBPACK FOOTER //
// ./src/routes.js